import { BalanceData } from "../../BalanceData";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDispatchBalance extends Layout {
    buttonDropdown: Button;
    buttonExpand: Button;
    horizontalspacerArea: HorizontalSpacer;
    labelAreaBalance1: Label;
    labelAreaBalance2: Label;
    labelAreaBalance3: Label;
    labelAreaBalance4: Label;
    labelAreaBalance5: Label;
    labelAreaBalance6: Label;
    labelAreaBalance7: Label;
    labelAreaTitle: Label;
    labelDay2: Label;
    labelDay3: Label;
    labelDay4: Label;
    labelDay5: Label;
    labelDay6: Label;
    labelDay7: Label;
    labelNoResults: Label;
    labelTodayDate: Label;
    labelZoneTitle: Label;
    layoutBalanceData: BalanceData;
    panelArea: Panel;
    panelAreaBalance: Panel;
    panelAreaHeader: Panel;
    panelAreas: Panel;
    panelDayHeader: Panel;
    panelEmpty: Panel;
    panelHeader: Panel;
    panelProfile: Panel;
    panelZone: Panel;
    panelZoneBalance: Panel;
    panelZoneExpand: Panel;
    panelZoneHeader: Panel;
    panelZoneHeaderButton: Panel;
    panelZones: Panel;
    sourceDispatchBalance: DataSource;
    textboxId: Textbox;
}
